import { render } from "./Stone.vue?vue&type=template&id=1799635a&scoped=true"
import script from "./Stone.vue?vue&type=script&lang=js"
export * from "./Stone.vue?vue&type=script&lang=js"

import "./Stone.vue?vue&type=style&index=0&id=1799635a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\alex3\\WD\\five-in-a-row\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1799635a"]])

export default __exports__